module.exports = __webpack_public_path__ + "img/Tendenz_unverändert.b29c85fb.svg";